import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis, scrollToTop } from "./hooks/useLenis";
import { SEO_ROUTES } from "./data/seo";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { BeforeAfter } from "./components/BeforeAfter";
import { WhyUs } from "./components/WhyUs";
import { Process } from "./components/Process";
import { Region } from "./components/Region";
import { QuoteForm } from "./components/QuoteForm";
import { Footer } from "./components/Footer";
import { MobileBar } from "./components/MobileBar";
import { Impressum } from "./pages/Impressum";
import { Datenschutz } from "./pages/Datenschutz";
import { Heckenschnitt } from "./pages/Heckenschnitt";
import { Hochdruckreinigung } from "./pages/Hochdruckreinigung";
import { Rasenpflege } from "./pages/Rasenpflege";
import { Gartenpflege } from "./pages/Gartenpflege";
import { Referenzen } from "./pages/Referenzen";
import { UeberMich } from "./pages/UeberMich";
import { Angebot } from "./pages/Angebot";

const SeoSync = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        const meta = SEO_ROUTES[pathname] || SEO_ROUTES["/"];
        const url = `https://www.julian-gartenservice.de${pathname}`;
        document.title = meta.title;
        document.querySelector('meta[name="description"]')?.setAttribute("content", meta.desc);
        document.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
        document.querySelector('meta[property="og:title"]')?.setAttribute("content", meta.title);
        document.querySelector('meta[property="og:description"]')?.setAttribute("content", meta.desc);
        document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
        scrollToTop();
    }, [pathname]);
    return null;
};

const Home = () => (
    <>
        <Header />
        <main>
            <Hero />
            <Marquee />
            <Services />
            <BeforeAfter />
            <WhyUs />
            <Process />
            <Region />
            <QuoteForm />
        </main>
        <Footer />
        <MobileBar />
    </>
);

function App() {
    useLenis();

    return (
        <BrowserRouter>
            <div className="min-h-screen bg-paper font-sans text-ink antialiased">
                <SeoSync />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/heckenschnitt-celle" element={<Heckenschnitt />} />
                    <Route path="/hochdruckreinigung-celle" element={<Hochdruckreinigung />} />
                    <Route path="/rasenpflege-celle" element={<Rasenpflege />} />
                    <Route path="/gartenpflege-celle" element={<Gartenpflege />} />
                    <Route path="/referenzen" element={<Referenzen />} />
                    <Route path="/ueber-mich" element={<UeberMich />} />
                    <Route path="/angebot" element={<Angebot />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                </Routes>
                <Toaster position="top-center" richColors closeButton toastOptions={{ className: "font-sans" }} />
            </div>
        </BrowserRouter>
    );
}

export default App;
